import { render } from "./Main.vue?vue&type=template&id=81f9f4ea&scoped=true&ts=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=81f9f4ea&lang=css&scoped=true"
import "./Main.vue?vue&type=style&index=1&id=81f9f4ea&lang=css"

import exportComponent from "/root/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81f9f4ea"]])

export default __exports__